import { PropsWithChildren } from "react";

export const IgnoreTrans: React.FunctionComponent<PropsWithChildren> = ({
  children,
}) => children;
